import React from 'react';
import styled from 'styled-components';

import InternalLink from '../InternalLink';
import { media } from '../styles/breakpoints';
import Title from './PatternCardHeader';
import Pattern from './PatternCardPattern';
import Card from '@material-ui/core/Card';

const StyledCard = styled(Card)`
        max-width: 400px;
        max-height: 95vh;
        margin-top: 1em;
        flex-shrink: 1;
        flex-grow:1;
        font-family:  ${props => props.theme.condensed};
        box-sizing: border-box;
        text-align: center;
        position: relative;
        padding-bottom: ${props => props.theme.space[3]};
        overflow: hidden;
        margin-right: 0.5em;
        margin-left: 0.5em;
        
        ${media.wideScreenUp`flex-basis: 23vw;`}
        ${media.normalLandscapeUp`flex-basis: 23vw;`}
        ${media.tweak900up`flex-basis: 30vw;`}
        ${media.normalPortraitUp`
          font-size: 0.95rem;
          flex-basis: 40vw; 
          max-width: 47%;
        `}
        ${media.tweak600up`
          font-size: 0.95rem;
          flex-basis: 80vw; 
          max-width: 400px;
        `}
        
        & a:hover {
            text-decoration-color: ${props => props.theme.palette.common.text};
        }
         
        & .stolo-gallery-img-link {
            display: block;
            border-bottom: 1px dashed #DDD;
        }
    
    & .card-to-bottom {
      margin-top: 0px;
      width: 100%;
    }
    
    @supports (display:grid){
       width: inherit;
       max-width: 92%;
       margin: 0 auto;
    }
    
   `;


const PatternCardBase = ({
    imgUri, LinkProps, title, children, overlay, overlayPath,
}) => (
    <StyledCard>
        <InternalLink to={LinkProps} className='stolo-gallery-img-link'>
            <Pattern imgUri={imgUri} overlay={overlay} overlayPath={overlayPath} />
        </InternalLink>

        <div className='card-to-bottom'>
            <InternalLink to={LinkProps}>
              <Title title={title} />
            </InternalLink>
            {children}
        </div>
    </StyledCard>
);

export default PatternCardBase;



// WEBPACK FOOTER //
// ./src/components/patterngalleries/PatternCardBase.js